import { push } from 'connected-react-router';
import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { SmartContainer } from '../../../styles/Containers';
import { StyledButton } from '../../../styles/matieralui/Button';
import { StyledP, StyledH6, StyledA, StyledH3, StyledH1 } from '../../../styles/StyledHTML';
import { Theme } from '../../../styles/Theme';
import { IconLock } from '../../Icons';
import { StyledCaptureCollabIcon } from '.././../../assets/CaptureCollabIconSVG';

export const StyledLockIcon = styled(SmartContainer)`
    background-color: ${Theme.colors.primary} !important;
    color: ${Theme.colors.primaryText};
    width: 50px;
    height: 50px;
    border-radius: 1000px;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        color: ${Theme.colors.primaryText} !important;
    }
`

export const NoPermissions = ({ checked }) => {

    const dispatch = useDispatch();
    const goTo = () => dispatch(push('/'));

    if (checked !== 'checked') {
        return (
            <SmartContainer flex align="center" justify="center" width="100%" minHeight="70vh">
                <StyledCaptureCollabIcon />
            </SmartContainer>
        )
    }

    return (
        <SmartContainer flex align="center" justify="center" width="100%" minHeight="70vh">
            <SmartContainer maxWidth="450px" textAlign="center">
                <SmartContainer flex align="center" justify="center" width="100%"><StyledLockIcon><IconLock color="white" /></StyledLockIcon></SmartContainer>
                <br />
                <StyledH1>Pump the breaks.</StyledH1>
                <br />
                <StyledP>You don't have access to this content. Ask your admin to change your permissions.</StyledP>
                <br />
                <StyledP><StyledButton variant='contained' color='blue' onClick={goTo}>Back Home</StyledButton></StyledP>
            </SmartContainer>
        </SmartContainer>
    )
}